module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 0
// module chunks = 0 1 2 3